var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCelebrationOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "150px",
    height: "150px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione-monotone",
    preserveAspectRatio: "xMidYMid meet",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.668 47.588c1.553-1.529.715-5.041-1.822-9.098c.922-.144 1.784-.364 2.436-.701c2.346-1.211 3.93-3.418 5.129-5.701c1.289-2.449 2.154-5.141 3.836-7.371c.284-.377.568-.715.851-1.033c3.629.435 6.526 1.215 6.526 1.215l1.107-2.813a29.917 29.917 0 0 0-4.286-1.187c.892-.507 1.474-.665 1.474-.665l-1.049-2.836c-1.682.711-3.047 1.76-4.19 3.016c-4.272-.239-8.574.612-11.968 3.244c-2.552 1.98-4.276 4.725-5.898 7.471a44.86 44.86 0 0 0-4.581-3.927c.306-.503.634-.955.987-1.304c2.133-2.1 4.947-3.443 6.793-5.846c3.88-5.046 1.042-12.956-2.15-17.052c-.572.551-1.518 1.354-2.23 1.988c3.393 3.475 5.766 9.559 3.107 14.105c-1.486 2.541-4.232 4.135-6.152 6.318c-.332.379-.629.859-.898 1.389c-5.021-3.601-9.629-5.05-11.455-3.252a2.35 2.35 0 0 0-.442.634l-.007-.007l-.049.143c-.068.155-.13.316-.172.492L2 61l36.662-12.818l-.01-.01c.394-.127.741-.314 1.016-.584M9.293 56.332l-3.06-1.426l2.065-5.95l9.471 4.412l-8.476 2.964m16.951-5.927l-15.879-7.399l2.065-5.949l11.866 5.956c-7.083-4.61-9.801-11.907-9.801-11.907l.706-2.033c1.255 3.175 4.016 7.129 7.81 10.861c3.826 3.766 7.881 6.494 11.122 7.713l-7.889 2.758m6.099-18.74c1.658-2.377 3.367-4.776 5.743-6.483c2.262-1.626 5.934-1.923 9.415-1.728c-1.176 2.054-2.045 4.333-2.825 6.522c-.943 2.65-2.207 5.398-4.617 7.023c-.65.438-1.561.758-2.534.995c-1.337-2.049-3.091-4.215-5.182-6.329",
    fill: "#818589"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.033 22c1.002 0-2.002-3-1.5-5.631c1.924-.148 6.322.719 3.762-2.797c2.896.51 4.396-1.652 1.662-3.701c.91.064 2.324-1.652 1.309-1.869c-3.252-.689-4.525 1.07-2.461 3.607c-2.17-.404-3.939.605-2.309 2.871c-6.266-.781-2.701 7.52-.463 7.52",
    fill: "#818589"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.545 19.334c.939-.424-.654-3.225-1.172-3.941c3.963-.424 3.813-1.605 1.328-4.135c6.756.227.209-3.613 1.127-5.133c.795-1.318 3.234.064 3.008-.67c-.762-2.455-7.99-.795-3.416 3.789c-3.992.078-4.375 1.383-1.4 4.088c-5.182.057-.954 6.668.525 6.002",
    fill: "#818589"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.697 29.225c-1.582.443-1.826.277-1.615 1.852c-3.654-1.682-7.52-4.021-5.174 2.176c-4.15-2.471-3.943-.307-4.719 3.254c-1.01-.787-2.445-2.861-2.445-2.861l-1.52 1.291s2.785 3.928 4.16 3.705c1.209-.195 1.867-2.48 1.934-4.494c3.85 1.625 5.693 1.842 3.932-2.91c3.078 1.729 6.852 3.254 5.447-2.013",
    fill: "#818589"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.049 11.437l2.828 2.829l-2.828 2.828l-2.829-2.828z",
    fill: "#818589"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.824 23.198l-2.83 2.828l-2.829-2.83l2.83-2.829z",
    fill: "#818589"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.22 7l2.828 2.828l-2.829 2.83l-2.828-2.83z",
    fill: "#818589"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.011 46.484l-2.83-2.829l2.828-2.83l2.83 2.829z",
    fill: "#818589"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.705 56.186l-2.828-2.828l2.828-2.829l2.829 2.829z",
    fill: "#818589"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.113 58.42l-2.83-2.829l2.827-2.83l2.83 2.829z",
    fill: "#818589"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.941 45.536l-2.828-2.829l2.828-2.828l2.828 2.828z",
    fill: "#818589"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.22 10l2.828 2.828l-2.829 2.829l-2.828-2.829z",
    fill: "#818589"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebrationOne);
export default __webpack_public_path__ + "static/media/celebration-one.b5a01d737133faf45bb3be6beadbfac3.svg";
export { ForwardRef as ReactComponent };